import { render, staticRenderFns } from "./ModalOverlay.vue?vue&type=template&id=f22c4baa&scoped=true"
import script from "./ModalOverlay.vue?vue&type=script&lang=js"
export * from "./ModalOverlay.vue?vue&type=script&lang=js"
import style0 from "./ModalOverlay.vue?vue&type=style&index=0&id=f22c4baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22c4baa",
  null
  
)

export default component.exports